import {AbstractEvent} from "@/modules/base/events";
import {Terrace} from "@/modules/stadium/entity";

export class BeforeTerraceExpendedEvent extends AbstractEvent {
  constructor(
    public terrace: Terrace,
    public oldSeats: number,
    public newSeats: number,
  ) {
    super();
  }
}